import { css } from "@emotion/react";

export const page = css`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;
